<template>
  <div></div>
</template>
<script>
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    path: {
      type: Array,
      required: true,
    },
  },
  data: () => ({}),
  mounted() {
    let bounds = new this.google.maps.LatLngBounds();
    if (typeof this.path !== "undefined") {
      this.path.forEach((item) => {
        bounds.extend(item);
      });
    }
    this.map.fitBounds(bounds);
  },
  methods: {},
};
</script>
